import React from 'react'
import { usePurchaseOrderListContext } from './Context'
import type { DataTableProps } from '@ztechapps/webui.data-tools'
import { DataTable } from '@ztechapps/webui.data-tools'
import { ListRow } from './ListRow'
import { ListHeader } from './ListHeader'
import type { SetOptional } from 'type-fest'
import type { PurchaseOrder } from '@ztechapps/common.contract'
import { purchaseOrderListFieldConfig } from './constants'

export const PurchaseOrderList = ({
  row,
  head,
  fields,
  listResult,
  tableOptions,
  ...props
}: SetOptional<DataTableProps<PurchaseOrder>, 'listResult' | 'fields'>) => {
  const { orderList, orderListWithSelection } = usePurchaseOrderListContext()
  const { list } = orderListWithSelection
  const defaultListResult = { ...orderList, list }
  return (
    <DataTable
      {...props}
      fields={fields ?? purchaseOrderListFieldConfig}
      listResult={listResult ?? defaultListResult}
      row={row ?? ListRow}
      head={head ?? ListHeader}
      tableOptions={{
        ...tableOptions,
        responsive: true,
      }}
    />
  )
}
